
<div class = "terms-area">
    <div class = "terms-text">
        <h1>UNION NEST 利用規約</h1>
        <p>制定日：2026年7月15日</p>

        <p>この利用規約（以下「本規約」といいます。）は、合同会社パルグロウ（以下「当社」といいます。）が提供する「UNION NEST」（以下「本サービス」といいます。）の利用条件を定めるものです。利用者は、本規約に同意のうえ本サービスを利用するものとします。</p>

        <hr>

        <h2>第1章 総則</h2>

        <h3>第1条（適用）</h3>
        <ol>
            <li>本規約は、本サービスの提供条件および当社と利用者との間の権利義務関係を定めます。</li>
            <li>当社が本サービス上または当社ウェブサイト等で提示するルール、ガイド、注意事項等（以下「個別規定」といいます。）は、本規約の一部を構成します。</li>
            <li>本規約と個別規定が矛盾する場合、個別規定が優先して適用されます（個別規定に別段の定めがある場合を除きます）。</li>
        </ol>

        <h3>第2条（定義）</h3>
        <p>本規約において用いる用語は、以下の各号のとおり定義します。</p>
        <ol>
            <li><strong>「利用組織」：</strong>本サービスの利用契約を当社と締結し、本サービスを利用する労働組合その他の団体・法人をいいます。</li>
            <li><strong>「利用者」：</strong>利用組織の役員・職員等で、利用組織により本サービスの利用を許諾された個人をいいます。</li>
            <li><strong>「管理者」：</strong>利用組織において、アカウント管理、公開範囲設定等の権限を付与された利用者をいいます。</li>
            <li><strong>「利用者データ」：</strong>利用者が本サービスに入力、登録、送信またはアップロードする情報（企画書・報告書・タグ・コメント・添付ファイル等を含みます。）をいいます。</li>
            <li><strong>「非公開情報」：</strong>利用組織または利用者が本サービス上の機能により非公開として設定した利用者データ（添付ファイルを含みます。）をいいます。</li>
            <li><strong>「公開情報」：</strong>利用者データのうち、非公開情報に該当しないものをいいます。</li>
            <li><strong>「統計情報等」：</strong>利用者データを集計・分析・加工して作成される統計情報、ならびに識別情報（氏名、メールアドレス、組織名等）を含まない形での個別情報（事例情報）をいいます。</li>
        </ol>

        <h3>第3条（規約の変更）</h3>
        <ol>
            <li>当社は、当社が必要と判断する場合、本規約を変更できるものとします。</li>
            <li>当社は、本規約を変更する場合、効力発生日および変更内容を、本サービス上への掲示その他当社所定の方法により周知します。</li>
            <li>変更後の本規約は、周知した効力発生日から適用されます。</li>
        </ol>


        <h2>第2章 利用契約等</h2>

        <h3>第4条（利用登録）</h3>
        <ol>
            <li>本サービスの利用を希望する者は、当社所定の方法により申込みを行い、当社が承諾した時点で、当社と利用組織との間に利用契約が成立します。</li>
            <li>当社は、申込み内容に虚偽、誤記または記載漏れがあった場合、申込みを承諾しないことがあります。</li>
        </ol>

        <h3>第5条（アカウント管理）</h3>
        <ol>
            <li>利用組織および利用者は、自己の責任においてアカウント情報を管理するものとし、第三者に利用させてはなりません。</li>
            <li>アカウントを用いて行われた本サービス上の一切の行為は、当該アカウントを付与した利用組織および当該利用者によるものとみなします。</li>
            <li>利用組織は、利用者の権限付与・剥奪、退職・交代時の停止等を適切に行うものとします。</li>
        </ol>

        <h3>第6条（利用環境）</h3>
        <p>利用者は、本サービスの利用に必要な端末、通信回線、ソフトウェア等を自己の費用と責任で準備するものとします。</p>


        <h2>第3章 利用料金等</h2>

        <h3>第7条（利用料金および支払）</h3>
        <ol>
            <li>利用組織は、当社が別途定める利用料金を、当社が指定する方法で支払うものとします。</li>
            <li>支払に要する費用（振込手数料等）は、利用組織の負担とします。</li>
        </ol>

        <h3>第8条（料金の改定）</h3>
        <ol>
            <li>当社は、経済情勢の変動、本サービスの内容・品質の変更その他合理的な事由がある場合、利用料金を改定できるものとします。</li>
            <li>当社は、料金改定を行う場合、原則として改定の効力発生日の60日前までに、本サービス上への掲示その他当社所定の方法により周知します。</li>
            <li>利用組織が改定後も本サービスを利用した場合、改定後の料金に同意したものとみなします。</li>
        </ol>

        <h3>第9条（追加機能等）</h3>
        <ol>
            <li>当社は、本サービスに新機能・有償オプション・追加プラン等（以下「追加機能等」といいます。）を追加または提供することがあります。</li>
            <li>追加機能等の利用には、別途当社が定める追加料金の支払または別途契約が必要となる場合があります。</li>
            <li>追加機能等の具体的内容、料金、提供条件等は、当社が別途提示するところによります。</li>
        </ol>


        <h2>第4章 利用者データの取扱い</h2>

        <h3>第10条（利用者データの権利帰属）</h3>
        <ol>
            <li>利用者データに関する権利は、当該利用者データを提供した利用組織または正当な権利者に留保されます。</li>
            <li>利用組織は、当社が本規約に定める範囲で利用者データを利用することについて、当社に対し必要な権利許諾を行うものとします。</li>
        </ol>

        <h3>第11条（当社による閲覧・分析（内部利用））</h3>
        <ol>
            <li>当社は、本サービスの提供・運用、保守、サポート対応、品質改善、セキュリティ確保、規約違反対応等に必要な範囲で、利用者データを取り扱います。</li>
            <li>当社は、統計情報等の作成や助言・分析の品質確保（ミスリード防止）に必要な範囲で、非公開情報を除く利用者データについて、利用組織名と紐づけた状態で内部的に閲覧・分析・検証することがあります。</li>
            <li>当社は、利用組織名と利用者データを紐づけた状態の情報を、当該利用組織の事前同意または法令に基づく場合を除き、第三者に提供または公開しません。</li>
        </ol>

        <h3>第12条（統計情報等の作成・利用（外部利用））</h3>
        <ol>
            <li>当社は、利用者データを集計・分析・加工して統計情報等を作成することができます。</li>
            <li>当社は、統計情報等を、レポート、資料、セミナー等での情報発信、CLM参画組織への開示、ならびに当社の助言・分析・コンサルティングその他関連事業の提供に利用できるものとします。</li>
            <li>前項に基づく外部利用において、当社は、利用組織名を開示しないものとし、特定の利用組織を識別できる形での提示を行いません。</li>
        </ol>

        <h3>第13条（非公開情報の取扱い）</h3>
        <ol>
            <li>当社は、原則として非公開情報を閲覧しません。ただし、第4項に定める場合を除きます。</li>
            <li>利用組織は、管理者の設定その他当社所定の方法により、当社に対し、非公開情報の全部または一部の閲覧を許可することができます。</li>
            <li>当社は、前項の許可を得た場合に限り、許可された目的および範囲内で非公開情報を閲覧・利用し、当該許可は利用組織により撤回できます。</li>
            <li>第11条第3項および前3項にかかわらず、利用組織は、当社および第19条に基づき当社が適切に監督する委託先が、本サービスの開発、運用、保守、動作確認、障害調査、セキュリティ確保その他本サービスの提供に必要な場合、必要最小限の範囲で非公開情報を閲覧または取り扱うことを、あらかじめ許諾するものとします。</li>
            <li>当社は、前項に基づく取扱いに当たり、委託先に秘密保持義務および必要な安全管理義務を課し、目的外利用を禁止するとともに、必要かつ適切な監督を行います。</li>
            <li>当社および委託先は、非公開情報の内容を閲覧せずに確認できる方法を優先し、障害調査その他本サービスの提供に必要不可欠な場合を除き、添付ファイルの内容を閲覧、ダウンロード、複製または印刷しません。</li>
        </ol>

        <h3>第14条（データの保持・削除（契約終了後を含む））</h3>
        <ol>
            <li>当社は、利用者データを、本サービスの提供・運用、保守、サポート、セキュリティ確保、法令遵守、紛争対応その他本規約に定める目的の達成に必要な期間、または当社が別途定める期間、保管します。</li>
            <li>利用契約が終了した場合、当社は、利用組織からの合理的な要請があるときは、当社所定の方法により、当該利用組織の利用者データのエクスポートまたは提供に合理的な範囲で対応します。ただし、他の利用組織の情報、当社または第三者の権利・利益を害するおそれがある情報、システムログその他当社の運用上必要な情報は、この限りではありません。</li>
            <li>利用契約が終了した場合、当社は、法令上の保存義務、料金精算、紛争対応、監査対応、セキュリティ確保その他本サービスの運用上合理的に必要な場合を除き、非公開情報および添付ファイルについて、当社所定の期間内に削除、利用停止、または識別不能化その他合理的な措置を講じます。</li>
            <li>前項にかかわらず、バックアップデータに含まれる利用者データは、バックアップの世代管理および保管期間の経過に伴い順次削除または上書きされるものとし、当社は、通常のバックアップ運用を超えて個別データのみを直ちに削除することを保証しません。</li>
            <li>利用者データのうち、利用組織または管理者が他組織への共有、統計情報等への利用、または外部利用の対象として設定した公開情報、ならびに当社が当該公開情報をもとに作成した統計情報等については、利用契約終了後も、本サービスのナレッジ維持、整合性確保、品質改善、情報発信、助言・分析その他本規約に定める目的の範囲で継続して保管・利用できるものとします。</li>
            <li>前項に基づく継続利用において、当社は、利用組織名、個人名、メールアドレスその他特定の利用組織または個人を識別できる情報を、当該利用組織の事前同意または法令に基づく場合を除き、第三者に提供または公開しません。</li>
            <li>当社は、第三者の権利侵害、個人情報の不適切な取扱い、営業秘密・機密情報の混入、秘密保持義務違反その他不適切な利用者データが含まれるおそれがあると合理的に判断した場合、当該情報を非公開化、削除、ダウンロード停止、利用停止その他必要な措置を講じることができます。</li>
            <li>本条に定めるデータの削除、利用停止、識別不能化または継続利用の具体的な手続、対象範囲および時期は、法令、本規約、利用契約、当社の運用基準ならびに当該利用者データの性質に従い、当社が合理的に定めるものとします。</li>
        </ol>

        <h3>第14条の2（AI機能等の取扱い）</h3>
        <ol>
            <li>当社は、本サービスにおいて、企画書・報告書の作成支援、検索支援、要約、分析、改善提案その他のAIを用いた機能（以下「AI機能」といいます。）を提供することがあります。AI機能は、当社が別途定める提供条件、利用範囲、料金および注意事項に従い利用されるものとします。</li>
            <li>AI機能により生成される文章、分析結果、提案、要約その他の出力内容（以下「AI出力」といいます。）は参考情報であり、その正確性、完全性、有用性、適法性、特定目的への適合性を保証するものではありません。利用組織および利用者は、AI出力を利用する場合、自らの責任で内容を確認し、最終判断を行うものとします。</li>
            <li>当社は、AI機能の提供、品質改善、セキュリティ確保、障害対応、規約違反対応等に必要な範囲で、AI機能の利用履歴、入力内容、AI出力、利用者ID、利用日時、処理結果その他のログを取得・保存・分析することがあります。</li>
            <li>当社は、非公開情報をAI機能に利用する場合、利用組織または管理者による設定、許可、利用範囲その他当社所定の条件に従い、許可された範囲内で取り扱います。利用組織または管理者が非公開情報のAI機能への利用を許可していない場合、当社は、当該非公開情報をAI機能の対象として利用しません。</li>
            <li>当社が外部のAIサービスまたはAI関連事業者を利用する場合、当社は、利用者データが当該外部AIサービスの基盤モデルの学習に利用されない設定または契約条件の利用を原則とし、必要な安全管理措置および委託先管理を講じます。ただし、外部AIサービスの具体的な提供条件は、当該サービス提供者の仕様変更等により変更される場合があります。</li>
            <li>利用組織および利用者は、AI機能を利用する場合であっても、法令、就業規則、組織内規程、秘密保持義務、個人情報保護に関する義務その他適用されるルールを遵守するものとし、適法な権限または同意なく、個人情報、要配慮個人情報、営業秘密、機密情報、第三者の権利を侵害する情報その他本サービスへの入力が不適切な情報を入力してはなりません。</li>
            <li>AI機能の提供開始時期、対象データ、利用可能な利用者範囲、利用停止方法その他の詳細は、当社が本サービス上または当社所定の方法により別途提示します。</li>
        </ol>


        <h2>第5章 利用者の義務等</h2>

        <h3>第15条（禁止事項）</h3>
        <p>利用者は、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
        <ol>
            <li>法令または公序良俗に違反する行為</li>
            <li>犯罪行為またはこれを助長する行為</li>
            <li>当社または第三者の知的財産権、名誉、信用、プライバシーその他の権利利益を侵害する行為</li>
            <li>第三者の個人情報を、適法な根拠なく入力・登録・アップロードする行為</li>
            <li>利用者または第三者の営業秘密、秘密情報、秘密保持義務に違反する情報を入力・登録・アップロードする行為</li>
            <li>本サービスの運営を妨害する行為、または当社のネットワークもしくはシステム等に過度な負荷をかける行為</li>
            <li>不正アクセス、なりすまし、アカウントの不正利用等の行為</li>
            <li>当社が定める公開範囲を逸脱し、他組織の情報を第三者へ開示する行為</li>
            <li>その他、当社が不適切と判断する行為</li>
        </ol>

        <h3>第16条（表明保証（権利・同意の取得等））</h3>
        <ol>
            <li>利用組織および利用者は、利用者データの登録・共有・公開設定に必要な一切の権利および同意（社内規程上の許可、秘密保持義務の遵守、本人同意等を含みます。）を適法に取得していることを表明し保証します。</li>
            <li>利用組織および利用者は、利用者データが第三者の権利利益を侵害しないこと、ならびに法令に違反しないことを表明し保証します。</li>
        </ol>

        <h3>第17条（秘密保持・第三者開示の禁止）</h3>
        <ol>
            <li>利用組織および利用者は、本サービスを通じて知り得た当社または他の利用組織に関する情報を、当社または当該利用組織の事前承諾なく第三者に開示または漏えいしてはなりません。</li>
            <li>前項は、法令または裁判所・行政機関の命令等により開示が必要となる場合を妨げません。この場合、可能な限り事前に当社へ通知するものとします。</li>
        </ol>

        <h3>第18条（反社会的勢力の排除）</h3>
        <ol>
            <li>利用組織および利用者は、自己またはその役員等が反社会的勢力に該当しないこと、および反社会的勢力と一切の関係を有しないことを表明し保証します。</li>
            <li>当社は、利用組織または利用者が前項に違反した場合、催告なく利用契約を解除し、または本サービスの利用を停止できます。</li>
        </ol>


        <h2>第6章 運用等</h2>

        <h3>第19条（委託）</h3>
        <p>当社は、本サービスの提供に必要な範囲で、その業務の全部または一部を第三者に委託できるものとします。</p>

        <h3>第20条（サービスの停止・中断）</h3>
        <p>当社は、以下のいずれかに該当する場合、事前通知なく本サービスの全部または一部を停止または中断できるものとします。</p>
        <ol>
            <li>システム保守点検または更新を行う場合</li>
            <li>天災地変、停電、通信障害等により提供が困難となった場合</li>
            <li>不正アクセス等のセキュリティ上の緊急対応が必要な場合</li>
            <li>その他、当社が停止または中断を必要と判断した場合</li>
        </ol>

        <h3>第21条（問い合わせ・サポート）</h3>
        <p>当社は、当社所定の方法により問い合わせ対応を行います。対応範囲、対応時間等は当社が別途定めるところによります。</p>


        <h2>第7章 解約・解除等</h2>

        <h3>第22条（解約）</h3>
        <p>利用組織は、当社所定の方法により、いつでも利用契約を解約できます。解約の効力発生日、支払済料金の取扱い等は当社が別途定めるところによります。</p>

        <h3>第23条（利用停止・解除）</h3>
        <ol>
            <li>当社は、利用組織または利用者が本規約に違反した場合、事前の催告なく、当該利用者の利用停止、利用組織の利用停止または利用契約の解除等の措置を講じることができます。</li>
            <li>当社は、利用者データが法令違反、第三者の権利侵害、営業秘密・機密情報の混入等のおそれがあると合理的に判断した場合、当該データの閲覧制限、非公開化、削除、ダウンロード停止等の措置を講じることができます。</li>
        </ol>

        <h3>第24条（契約終了後の取扱い）</h3>
        <p>利用契約終了後も、第11条（当社による閲覧・分析）、第12条（統計情報等の作成・利用）、第14条（データの保持・削除）、第14条の2（AI機能等の取扱い）、第17条（秘密保持）、第25条（免責）、第26条（責任制限）、第27条（補償）、第30条（準拠法・管轄）の定めは有効に存続します。</p>


        <h2>第8章 免責・責任等</h2>

        <h3>第25条（免責）</h3>
        <ol>
            <li>当社は、本サービスが利用者の特定の目的に適合すること、期待する機能・価値・正確性を有すること、継続的に提供されること等について、明示または黙示を問わず保証しません。</li>
            <li>当社は、利用者データの内容の正確性、適法性、完全性について保証せず、利用者データに起因して生じた損害について責任を負いません（当社の故意または重過失による場合を除きます）。</li>
        </ol>

        <h3>第26条（損害賠償・責任制限）</h3>
        <ol>
            <li>当社が本サービスに関して利用組織に対して損害賠償責任を負う場合であっても、当社の故意または重過失による場合を除き、当社の責任は、直近12か月間に当該利用組織が当社に支払った利用料金の総額を上限とします。</li>
            <li>当社は、逸失利益、間接損害、特別損害、付随的損害について責任を負いません（当社の故意または重過失による場合を除きます）。</li>
        </ol>

        <h3>第27条（補償）</h3>
        <p>利用組織および利用者は、利用者データの登録・利用・公開設定その他本サービスの利用に起因して当社または第三者に生じた一切の請求、損害、損失、費用（合理的な弁護士費用を含みます。）を、自己の責任と費用で解決し、当社を補償するものとします。</p>


        <h2>第9章 その他</h2>

        <h3>第28条（知的財産権）</h3>
        <p>本サービスおよび本サービスに関連するプログラム、デザイン、文章、商標等に関する知的財産権は、当社または正当な権利者に帰属します。</p>

        <h3>第29条（通知）</h3>
        <p>当社から利用組織への通知は、当社が別途定める方法（メール、本サービス上の掲示等）により行うものとします。</p>

        <h3>第30条（準拠法・管轄）</h3>
        <p>本規約の準拠法は日本法とし、本サービスまたは本規約に起因または関連する紛争については、（記入）を第一審の専属的合意管轄裁判所とします。</p>

        <h3>第31条（問い合わせ窓口）</h3>
        <p>本サービスおよび本規約に関するお問い合わせは、以下までご連絡ください。</p>
        <ul>
            <li>合同会社パルグロウ NEST運営窓口</li>
            <li><strong>メール：</strong><a href="mailto:support@palgrow.co.jp">support@palgrow.co.jp</a></li>
            <li><strong>住所：</strong>東京都渋谷区渋谷2丁目19番地15号 宮益坂ビルディング6F</li>
        </ul>

        <p>以上</p>
    </div>
</div>